// This are the Filter component in the filters sidebar
import { Fragment } from 'react';
import { searchToolFilters } from '../../customize/const';
import Selector from '../../generic/Selector';
import { connect } from 'react-redux';
import {
  toggleRecipeFilter,
  clearRecipeFilters,
  applyRecipeFilters,
  getFilteredRecipes,
} from '../../customize/actions_creators';
import HorizontalLine from '../../generic/HorizontalLine';

const RecipesFilters = ({
  selectedFilters,
  toggleFilter,
  clearFilters,
  applyFilters,
  refreshRecipes,
  tagOptions,
  tagOptionsOrder,
}) => {
  const {
    favorite,
    featured,
    serving_size,
    max_calories,
    dietary,
    max_cooking_time,
    protein,
    spicy_level,
  } = searchToolFilters;

  const clearAndGet = () => {
    clearFilters();
    refreshRecipes();
  };

  const applyAndGet = () => {
    applyFilters();
    refreshRecipes();
  };

  const preCheckout = !!parseInt(window.preCheckout);

  if (preCheckout) {
    if (!selectedFilters.featured.includes('is_featured')) {
      toggleFilter('is_featured', 'featured');
      applyAndGet();
    }
  }

  const renderFeaturedFilters = () => {
    return (
      <div>
        <div
          className="hr-subtitle-md-bold hr-mb-16"
          data-testid={`filter-title-${favorite.title.replace(' ', '-')}`}
        >
          {favorite.title}
        </div>
        <Selector
          options={favorite.options}
          action={(val) => toggleFilter(val, 'favorite')}
          type="checkbox"
          selected={selectedFilters.favorite}
        />
        <HorizontalLine />
        <div className="hr-subtitle-md-bold hr-mb-16">{featured.title}</div>
        <Selector
          options={featured.options}
          action={(val) => toggleFilter(val, 'featured')}
          type="checkbox"
          selected={selectedFilters.featured}
        />
        <HorizontalLine />
      </div>
    );
  };

  return (
    <div className="filters-container">
      {!preCheckout ? renderFeaturedFilters() : null}
      <div className="hr-subtitle-md-bold hr-mb-16">{serving_size.title}</div>
      <Selector
        options={serving_size.options}
        action={(val) => toggleFilter(val, 'serving_size')}
        type="radio"
        selected={
          selectedFilters.serving_size ? selectedFilters.serving_size : 2
        }
      />
      <HorizontalLine />
      <div className="hr-subtitle-md-bold hr-mb-16">{protein.title}</div>
      <Selector
        options={tagOptions}
        action={(val) => toggleFilter(val, 'protein')}
        type="checkbox"
        selected={selectedFilters.protein}
        optionsOrder={tagOptionsOrder}
      />
      <HorizontalLine />
      <div className="hr-subtitle-md-bold hr-mb-16">{spicy_level.title}</div>
      <Selector
        options={spicy_level.options}
        action={(val) => toggleFilter(val, 'spicy_level')}
        type="checkbox"
        selected={selectedFilters.spicy_level}
      />
      <HorizontalLine />
      <div className="hr-subtitle-md-bold hr-mb-16">
        {max_cooking_time.title}
      </div>
      <Selector
        options={max_cooking_time.options}
        action={(val) => toggleFilter(val, 'max_cooking_time')}
        type="checkbox"
        selected={selectedFilters.max_cooking_time}
      />
      <HorizontalLine />
      <div className="hr-subtitle-md-bold hr-mb-16">{max_calories.title}</div>
      <Selector
        options={max_calories.options}
        action={(val) => toggleFilter(val, 'max_calories')}
        type="checkbox"
        selected={selectedFilters.max_calories}
      />
      <HorizontalLine />
      {Object.keys(dietary.options).length ? (
        <Fragment>
          <div className="hr-flex flex-break hr-mb-16">
            <div className="hr-subtitle-md-bold hr-mb-8">
              {dietary.title} &nbsp;
            </div>
            <span className="multi-select-txt">(select all that apply)</span>
          </div>
          <Selector
            options={dietary.options}
            action={(val) => toggleFilter(val, 'dietary')}
            type="checkbox"
            selected={selectedFilters.dietary}
          />
          <HorizontalLine />
        </Fragment>
      ) : null}
      <div className="placeholder-element"></div>
      <div className="filter-btns">
        <button onClick={clearAndGet} className="hr-btn-hol">
          Clear
        </button>
        <button onClick={applyAndGet} className="hr-btn-blue">
          Apply
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedFilters: state.filters.selectedRecipeFilters,
    dietaryPreferences: state.filters.dietaryPreferences,
    tagOptions: state.filters.tagOptions,
    tagOptionsOrder: state.filters.tagOptionsOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleFilter: (f, fc) => dispatch(toggleRecipeFilter(f, fc)),
    clearFilters: () => dispatch(clearRecipeFilters()),
    applyFilters: () => dispatch(applyRecipeFilters()),
    refreshRecipes: () => dispatch(getFilteredRecipes()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RecipesFilters);
